<div
    class="absolute inset-0 flex flex-col min-w-0 overflow-y-auto"
    cdkScrollable>

    <!-- Header -->
    <div class="relative flex-0 py-8 px-4 sm:p-16 overflow-hidden bg-gray-800 dark">
        <!-- Background - @formatter:off -->
        <!-- Rings -->
        <svg class="absolute inset-0 pointer-events-none"
             viewBox="0 0 960 540" width="100%" height="100%" preserveAspectRatio="xMidYMax slice" xmlns="http://www.w3.org/2000/svg">
            <g class="text-gray-700 opacity-25" fill="none" stroke="currentColor" stroke-width="100">
                <circle r="234" cx="196" cy="23"></circle>
                <circle r="234" cx="790" cy="491"></circle>
            </g>
        </svg>
        <!-- @formatter:on -->
        <div class="z-10 relative flex flex-col items-center">
            <h2 class="text-xl font-semibold">ESEEL HIRE</h2>
            <div class="mt-1 text-4xl sm:text-7xl font-extrabold tracking-tight leading-tight text-center">
                Who do you want to hire?
            </div>
            <div class="max-w-2xl mt-6 sm:text-2xl text-center tracking-tight text-secondary">
                We make sure your payments are only released when your agreement is satisfied.
                <!-- Our profiles will step you through the process of a building small applications, or adding new features to existing applications. -->
            </div>
        </div>
    </div>

    <!-- Main -->
    <div class="flex flex-auto p-6 sm:p-10">

        <div class="flex flex-col flex-auto w-full max-w-xs sm:max-w-5xl mx-auto">
            <!-- Filters -->
            <!-- <div class="flex flex-col sm:flex-row items-center justify-between w-full max-w-xs sm:max-w-none">
                <mat-form-field class="fuse-mat-no-subscript w-full sm:w-36">
                    <mat-select
                        [value]="'all'"
                        (selectionChange)="filterByCategory($event)">
                        <mat-option [value]="'all'">All</mat-option>
                        <ng-container *ngFor="let category of categories; trackBy: trackByFn">
                            <mat-option [value]="category.slug">{{category.title}}</mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
                <mat-form-field
                    class="fuse-mat-no-subscript w-full sm:w-72 mt-4 sm:mt-0 sm:ml-4"
                    [floatLabel]="'always'">
                    <mat-icon
                        matPrefix
                        class="icon-size-5"
                        [svgIcon]="'heroicons_solid:search'"></mat-icon>
                    <input
                        (input)="filterByQuery(query.value)"
                        placeholder="Search by title or description"
                        matInput
                        #query>
                </mat-form-field>
                <mat-slide-toggle
                    class="mt-8 sm:mt-0 sm:ml-auto"
                    [color]="'primary'"
                    (change)="toggleCompleted($event)">
                    Hide completed
                </mat-slide-toggle>
            </div> -->
            <!-- Courses -->
            <!-- <ng-container *ngIf="this.filteredCourses.length; else noCourses"> -->
            <ng-container >
                <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-8 sm:mt-10">
                    <ng-container *ngFor="let profile of profiles; trackBy: trackByFn">
                        <!-- Course -->

                        <fuse-card [routerLink]="['/s', profile.store.online_id]" class="flex items-center max-w-80 w-full p-6 filter-info">
                            <img *ngIf="profile.profile_img_name"
                            class="w-20 h-20 mr-6 rounded-full"
                            src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + profile.store.online_id + '/profile/' + profile.profile_img_name  }}"
                            alt="Card profile image">
                        <img *ngIf="!profile.profile_img_name"
                        class="w-20 h-20 mr-6 rounded-full"
                            src="assets/images/logo/eseel_logo_hire_user.png"
                            alt="Card profile image">

                            <div class="flex flex-col">
                                <div class="text-2xl font-semibold leading-tight"> {{profile.title}} </div>
                                <div class="text-md text-secondary">{{profile.store.city}}, {{profile.store.province}}</div>
                            </div>
                        </fuse-card>
                    </ng-container>
                </div>
            </ng-container>

            <!-- No profiles -->
            <ng-template #noCourses>
                <div class="flex flex-auto flex-col items-center justify-center bg-gray-100 dark:bg-transparent">
                    <mat-icon
                        class="icon-size-20"
                        [svgIcon]="'iconsmind:file_search'"></mat-icon>
                    <div class="mt-6 text-2xl font-semibold tracking-tight text-secondary">No profiles found!</div>
                </div>
            </ng-template>
        </div>

    </div>

</div>
